export const formatMessage = (message) => {
  if (typeof message !== "string") return <>{""}</>;

  const regex = /'(.*?)'/;
  const match = regex.exec(message);

  if (!match) return <>{message}</>;

  const fileName = match[1];
  const [before, after] = message.split(`'${fileName}'`);

  return (
    <>
      {before}&apos;
      <span
        style={{
          display: "inline-block",
          maxWidth: "180px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          verticalAlign: "bottom",
        }}
        title={fileName}
      >
        {fileName}
      </span>
      &apos;{after}
    </>
  );
};

export const formatNotificationSettingsLabel = (key) => {
  switch (key) {
    case "signatureRequestEmail":
      return "E-Signature Request Email";
    case "signatureReminderEmail":
      return "E-Signature Reminder Email";
    case "signatureRequestSms":
      return "E-Signature Request SMS";
    case "signatureReminderSms":
      return "E-Signature Reminder SMS";
    case "externalShareEmail":
      return "External Share Email";
    default:
      return key;
  }
};
